import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import chatbot from "../../Assets/Projects/chatbot.png";
import chatify from "../../Assets/Projects/chatify.png";
import weatherApp from "../../Assets/Projects/weatherApp.png";
import dalle from "../../Assets/Projects/dall-e.png";
import noteApp from "../../Assets/Projects/note-app.png";
import restaurant from "../../Assets/Projects/vam-restaurant.png";
import mobileApp from "../../Assets/Projects/react-native-app.png";
import simpleMovie from "../../Assets/Projects/react-simple-movie.png";
import AISaaS from "../../Assets/Projects/ai-saas.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={restaurant}
              isBlog={false}
              title="VAM Restaurant"
              description="Restaurant food ordering app build with Next.js Prisma full project using PostgreSQL, Auth.js, Stripe, Docker, React Query and Zustand."
              ghLink="https://github.com/vamnguyen/vam-restaurant"
              demoLink="https://vam-restaurant.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AISaaS}
              isBlog={false}
              title="Genius AI SaaS"
              description="AI Software as a Service platform with 5 AI tools. Implemented Crisp Chatbox to support Customers. Tech use: NextJS, React, Tailwind, Prisma, Stripe, PostgreSQL, Crisp Chat,..."
              ghLink="https://github.com/vamnguyen/AI-SaaS"
              demoLink="https://vam-ai-saas.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={noteApp}
              isBlog={false}
              title="Note App"
              description="With Vite optimizing performance, this full-stack note app is your ultimate tool for organized and efficient note management. Tech use: React, Node.js (Express.js), GraphQL-WebSocket, MongoDB, Firebase, MUI,..."
              ghLink="https://github.com/vamnguyen/note-app"
              demoLink="https://note-app-weld-one.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mobileApp}
              isBlog={false}
              title="React Native App"
              description="Mobile App cross-platform (IOS/Android/Web) build with React Native, Expo, React.js. Support User find perfect jobs, apply jobs,..."
              ghLink="https://github.com/vamnguyen/mobile-programing"
              demoLink="https://expo.dev/@vamnguyen/react-native-jobs?serviceType=classic&distribution=expo-go"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chat App"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with React.js and Firebase version 9+. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/vamnguyen/realtime-chat-app"
              demoLink="https://simple-chat-app-rosy.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dalle}
              isBlog={false}
              title="DALL-E OpenAI"
              description="DALL-E clone build with MERN stack technology and Cloudinary: A cloud-based image storage service. OpenAI's DALL-E model: A deep learning model that generates images from text input."
              ghLink="https://github.com/vamnguyen/DALL-E_OpenAI"
              demoLink="https://dall-e-open-ai-alpha.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weatherApp}
              isBlog={false}
              title="Weather app"
              description="Weather app build simple support user search temperature, wind, humidity,... of city in the world. Additionally, virtual assistant speech recognition not support Edge browser."
              ghLink="https://github.com/vamnguyen/weather-app"
              demoLink="https://weather-app-virid-eta.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatbot}
              isBlog={false}
              title="Chatbot Messenger Restaurant"
              description="Chatbot builds with Node.js and Docs on Messenger Platform. Chatbot's feature supplies info about restaurants for Users. Additionally, support customer table reservations via Webview..."
              ghLink="https://github.com/vamnguyen/chatbot-fb-messenger-restaurant"
              demoLink="https://www.facebook.com/vamnguyenpage/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={simpleMovie}
              isBlog={false}
              title="Simple Movie Website"
              description="Create an engaging and user-friendly movie website with React, powered by the popular TMDB (The Movie Database) API. This simple movie website will allow users to explore and discover a vast collection of movies, including details, ratings, and more. Here's what you can expect from this project."
              ghLink="https://github.com/vamnguyen/react-simple-movie"
              demoLink="https://react-simple-movie-three.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
